// removed by extract-text-webpack-plugin
module.exports = {"section":"AppBanner__section___114km","container":"AppBanner__container___FKErN","icon":"AppBanner__icon___2Imob","icon-placeholder":"AppBanner__icon-placeholder___4KUvc AppBanner__icon___2Imob","name":"AppBanner__name___Xvq5P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/AppBanner.scss
// module id = 517
// module chunks = 0